/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import {Mug} from 'react-kawaii';
import {zoomInRight, zoomOutRight, fadeIn, fadeOut, bounce, pulse} from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Button } from '@material-ui/core';

const animationStyles = {
  zoomInRight: {
    animation: 'x 1s',
    animationName: Radium.keyframes(zoomInRight, 'zoomInRight')
  },
  zoomOutRight: {
    animation: 'x 1.5s',
    animationName: Radium.keyframes(zoomOutRight, 'zoomOutRight')
  },
  fadeIn: {
    animation: 'x 1s',
    animationName: Radium.keyframes(fadeIn, 'fadeIn')
  },
  fadeOut: {
    animation: 'x 0.2s',
    animationName: Radium.keyframes(fadeOut, 'fadeOut')
  },
  bounce: {
    animation: 'x 1s',
    animationName: Radium.keyframes(bounce, 'bounce')
  },
  pulse: {
    animation: 'x 1s',
    animationName: Radium.keyframes(pulse, 'pulse')
  },
}

const styles = theme => ({
  root: {
    //position: 'absolute',
    //top: 0,
    //left: 0,
    //height: 'calc(100% - 3px)',
    width: '100%',
    background: '#f9f9f9',
    borderRadius: '4px',
    padding: '16px 0 0 0',
    textAlign: 'left',
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(4),
    marginBottom: 0,
    color: '#fff',
    //position: 'absolute',
    //bottom: 15
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
    marginRight: -theme.spacing(1) * 0.5,
  },
  speechBubbleWrapper: {
    marginBottom: 30,
    position: 'relative'
  },
  speechBubble: {
    padding: '15px 30px',
    borderRadius: 10,
    background: '#ffffff',
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.3)',
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 16,
    color: '#000000',
    lineHeight: 1.35,
  },
  speakerWrapper: {
    padding: '0 30px',
  },
  hidden: {
    opacity: 0
  },
  description: {
    textAlign: 'center',
    paddingTop: '32px!important',
  },
});

class Motivation extends Component {
  state = {
    animation: animationStyles.zoomInRight,
    speechBubbleAnimation: null,
    show: true,
    showSpeechBubble: false,
    closing: false,
    mood: 'excited'
  }

  componentDidMount() {
    this.timeout1 = setTimeout(() => {
      this.setState({showSpeechBubble: true, speechBubbleAnimation: animationStyles.fadeIn})
    }, 750)

    this.timeout2 = setTimeout(() => {
      this.setState({mood: 'blissful'})
    }, 4000)

    this.timeout3 = setTimeout(() => {
      this.setState({animation: animationStyles.pulse})
    }, 5000)

    this.timeout4 = setTimeout(() => {
      this.setState({mood: 'excited'})
    }, 14000)

    this.timeout5 = setTimeout(() => {
      this.setState({animation: animationStyles.bounce})
    }, 16000)

  }


  handleClose = () => {
    clearTimeout(this.timeout1)
    clearTimeout(this.timeout2)
    clearTimeout(this.timeout3)
    clearTimeout(this.timeout4)
    clearTimeout(this.timeout5)

    this.setState({
      speechBubbleAnimation: animationStyles.fadeOut
    })
    setTimeout(() => {
      this.setState({
        animation: animationStyles.zoomOutRight,
        closing: true,
        showSpeechBubble: false,
      })
      this.close();
    }, 180)
  }

  close = () => {
    if (this.props.url) {
      setTimeout(() => {
        this.setState({show: false})
      }, 750)
      if (this.props.url === 'reload') {
        window.location.reload()
      } else {
        window.location = this.props.url
      }
    } else {
      setTimeout(() => {
        this.props.onClose();
      }, 750)
    }
  }

  render() {
    const {classes, text, buttonText} = this.props;
    return (<>
          <div className={classes.root + ' ' + (!this.state.show ? classes.hidden : '')}>
            <StyleRoot>
              <div>
                <div className={classes.speechBubbleWrapper}>
                  <div
                      className={'speechBubble ' + classes.speechBubble + ' ' + (!this.state.showSpeechBubble ? classes.hidden : '')}
                      style={this.state.speechBubbleAnimation}>
                    {text}
                  </div>
                </div>
                <div className={classes.speakerWrapper} style={this.state.animation}>
                  <Mug size={100} mood={this.state.mood} color="#FCCB7E"/>
                </div>
              </div>
              <div style={this.state.speechBubbleAnimation}
                   className={(!this.state.showSpeechBubble ? classes.hidden : '')}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.button}
                    onClick={this.handleClose}
                    disabled={this.state.closing}
                >
                  {buttonText}
                  <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                   icon={['far', 'shield-check']}/>
                </Button>
              </div>
            </StyleRoot>
          </div>
        </>
    )
  }
}

export default withStyles(styles)(Motivation);
